// @module Digi.SupportDocs.SupportDocs
define('IMEIManager.View',
    [
        'imeimanager.tpl',
        'IMEIManager.List.View',
        'IMEIManager.Collection',
        'Backbone'
    ],
    function (
        imeimanager_tpl,
        IMEIManagerListView,
        IMEIManagerCollection,
        Backbone,

    ) {
        'use strict';

        // @class Digi.SupportDocs.SupportDocs.View @extends Backbone.View
        return Backbone.View.extend({

            template: imeimanager_tpl,

            initialize: function (options) {

                this.container = options.container;
                this.layout = options.container.getComponent('Layout');
                this.pdp = options.container.getComponent('PDP');

            },

            events: {
                "click [data-action='showModal']": "showModal"
            },

            myEvent: function myEvent() {
                console.log('here');
                this.pdp.getItemInfo();
            },

            //@method getContext @return Digi.SupportDocs.SupportDocs.View.Context
            getContext: function getContext() {
            },

            showModal: function showModal(e) {
                var self = this;
                var modalView

                e.preventDefault();

                modalView = new IMEIManagerListView({
                    container: this.container
                });

                self.layout.showContent(modalView, {
                    showInModal: true, options: { 'auto-hide': false }
                });

            }

        });
    });
